import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=427b1844&scoped=true&"
import script from "./PaymentForm.vue?vue&type=script&lang=js&"
export * from "./PaymentForm.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=427b1844&scoped=true&lang=css&"
import style1 from "./PaymentForm.vue?vue&type=style&index=1&id=427b1844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b1844",
  null
  
)

export default component.exports